// NS: ページ遷移アニメーション（View Transitions）は新しいページの準備ができるまで
// 古い画面を表示したままにするため、タップから1〜1.8秒ほど画面が一切変化せず
// 「押せたのか分からない」状態になっていた。
// サーバー応答は15〜40msと速いので、待ち時間そのものではなく
// 「押した合図」と「読み込み中の合図」を出して体感を埋める。
//
// 速度に影響しない作り:
//   - 追加のファイル読み込みは無し。合図はすでに表示中の古いページの上に描くだけ
//   - 動かすのは transform と opacity だけ（width や left は使わない）ので
//     レイアウトの再計算が起きず、ページの処理を止めない
(() => {
  const HOLD_AT = 0.9; // 遷移完了までは 90% で止めておく
  const RISE_MS = 1200;
  const LINE_MS = 900;
  const GIVE_UP_MS = 8000;

  // ヘッダーのカテゴリのように、狭く並んだ細いリンク
  const NARROW = 'header, nav, .menu-list, .menu-drawer, .chnav, .header, .announcement-bar';

  let bar = null;
  let fill = null;
  const overlays = [];
  let pressed = null;
  let giveUpTimer;

  function el(cls) {
    const node = document.createElement('div');
    node.className = cls;
    node.setAttribute('aria-hidden', 'true');
    document.body.appendChild(node);
    overlays.push(node);
    return node;
  }

  function ensureBar() {
    if (bar && bar.isConnected) return bar;
    // 外側＝溝（全幅・動かない）／内側＝進捗（赤・伸びる）
    // 告知バーの赤と読み込みバーの赤が同じ色で、最上部では見えなかった。
    // 先に溝を敷いて背景から切り離す。
    bar = document.createElement('div');
    bar.className = 'ns-navbar';
    bar.setAttribute('aria-hidden', 'true');
    fill = document.createElement('div');
    fill.className = 'ns-navbar__fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);
    return bar;
  }

  function startBar() {
    ensureBar();
    fill.style.transition = 'none';
    fill.style.transform = 'scaleX(0)';
    bar.classList.add('is-on');
    void fill.offsetWidth;
    fill.style.transition = `transform ${RISE_MS}ms cubic-bezier(.15,.75,.35,1)`;
    fill.style.transform = `scaleX(${HOLD_AT})`;
  }

  /** 狭いリンク：下に線が伸びる */
  function underline(anchor) {
    const r = anchor.getBoundingClientRect();
    // 画面の外（閉じたドロワーの中など）には描かない
    if (r.width < 8) return;
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    if (r.right < 0 || r.left > window.innerWidth) return;
    const line = el('ns-uline');
    line.style.left = `${r.left}px`;
    line.style.top = `${r.bottom - 1}px`;
    line.style.width = `${r.width}px`;
    void line.offsetWidth;
    line.style.transition = `transform ${LINE_MS}ms cubic-bezier(.15,.75,.35,1)`;
    line.style.transform = 'scaleX(1)';
  }

  /**
   * 回転印を出す位置。指の座標をそのまま使う。
   * 要素の位置から計算すると、テーマ側がカードを差し替えたり
   * 遷移の準備で要素が外れたりしたときに座標が 0,0 になり、
   * 画面左上に見切れて出てしまうため。
   */
  function pointFrom(event, anchor) {
    if (event && (event.clientX || event.clientY)) {
      return { x: event.clientX, y: event.clientY };
    }
    // キーボード操作など座標が無いときだけ要素から求める
    const r = anchor.getBoundingClientRect();
    if (r.width < 4 || r.height < 4) return null;
    return { x: r.left + r.width / 2, y: r.top + Math.min(r.height / 2, window.innerHeight / 2) };
  }

  /** 大きい要素：沈み込み＋回転印 */
  function spinner(anchor, event) {
    const p = pointFrom(event, anchor);
    if (!p) return;
    const pad = 24;
    const x = Math.min(Math.max(p.x, pad), window.innerWidth - pad);
    const y = Math.min(Math.max(p.y, pad), window.innerHeight - pad);
    const spin = el('ns-spin');
    spin.style.left = `${x}px`;
    spin.style.top = `${y}px`;
    anchor.classList.add('ns-pressed');
    pressed = anchor;
  }

  function reset() {
    clearTimeout(giveUpTimer);
    if (bar) {
      bar.classList.remove('is-on');
      if (fill) {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(0)';
      }
    }
    while (overlays.length) overlays.pop().remove();
    if (pressed) {
      pressed.classList.remove('ns-pressed');
      pressed = null;
    }
  }

  /** @param {MouseEvent} event */
  function onClick(event) {
    if (event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target = event.target;
    const anchor = target instanceof Element ? target.closest('a[href]') : null;
    if (!(anchor instanceof HTMLAnchorElement)) return;
    if (anchor.target && anchor.target !== '_self') return;
    if (anchor.hasAttribute('download')) return;

    let url;
    try {
      url = new URL(anchor.href, location.href);
    } catch {
      return;
    }
    if (url.origin !== location.origin) return;
    // 同じページ内のアンカーは遷移しないので出さない
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;

    reset();
    startBar();
    if (anchor.closest(NARROW)) underline(anchor);
    else spinner(anchor, event);
    giveUpTimer = window.setTimeout(reset, GIVE_UP_MS);
  }

  document.addEventListener('click', onClick);

  // 戻る／進む（bfcache 復帰）や、遷移がキャンセルされたときに残らないようにする
  window.addEventListener('pageshow', reset);
  window.addEventListener('pagehide', reset);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reset();
  });
})();
